const wecomBinding = {
  title: '企业微信账号绑定',
  subtitle: '使用企业微信身份登录并完成账号绑定',
  subtitleWithApp: '完成身份验证后即可继续使用“{{app}}”',
  processing: '正在核对绑定结果…',
  auth: {
    action: '使用企业微信登录',
    description:
      '请在企业微信中继续。系统将使用统一的企微免密登录流程；首次使用时，按提示授权企业邮箱或完成账号绑定。',
  },
  success: { title: '绑定成功，可以继续对话。', description: '请返回企业微信继续发送消息。' },
  expired: { title: '绑定链接已过期', description: '请返回企业微信重新发起绑定。' },
  conflict: {
    title: '企业微信身份不匹配',
    description: '请使用发起对话的企业微信账号重新打开链接；如仍无法完成，请联系管理员。',
  },
  channelClosed: {
    title: 'IM 对话功能已关闭',
    description: '此应用的 IM 对话功能已被管理员关闭，请联系应用管理员。',
  },
  error: {
    title: '暂时无法完成绑定',
    description: '请重试，或返回企业微信重新发起绑定。',
    retry: '重试',
  },
}
export default wecomBinding
